import { Link } from 'gatsby';
import React, { FC, ReactNode } from 'react';

type RowProps = {
  children: ReactNode;
  key?: string | number;
  to?: string;
  className?: string;
  onClick?: () => void;
  onEnter?: () => void;
  onLeave?: () => void;
};

export const TableRow: FC<RowProps> = ({
  children,
  key,
  to,
  onClick,
  className,
  onEnter,
  onLeave,
}) => {
  const rowContent = to ? (
    <Link to={to} className="contents">
      {children}
    </Link>
  ) : (
    children
  );

  return (
    <tr
      key={key}
      onClick={onClick}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}
      className={`group hover:bg-slate-50 dark:hover:bg-slate-600 ${className} ${
        onClick ? 'cursor-pointer' : ''
      }`}
    >
      {rowContent}
    </tr>
  );
};

export default TableRow;
